// @ts-nocheck
import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

interface UsePremiumAccessProps {
  onUpgradeRequired: () => void;
}

export function usePremiumAccess({ onUpgradeRequired }: UsePremiumAccessProps) {
  const { profile } = useAuth();
  const [showUpgradeMessage, setShowUpgradeMessage] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  // Check membership premium status from database
  useEffect(() => {
    const checkPremiumStatus = async () => {
      if (!profile?.active_membership_slug) {
        setIsPremium(false);
        setIsLoading(false);
        return;
      }

      try {
        // Query the memberships table to check if this membership is premium
        const { data, error } = await supabase
          .from('memberships')
          .select('is_premium, is_active')
          .eq('slug', profile.active_membership_slug)
          .single();

        if (error) {
          console.error('Error checking premium status:', error);
          setIsPremium(false);
        } else {
          // User has premium if membership exists, is active, and is_premium is true
          setIsPremium(data?.is_active === true && data?.is_premium === true);
        }
      } catch (err) {
        console.error('Error in premium check:', err);
        setIsPremium(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkPremiumStatus();
  }, [profile?.active_membership_slug]);
  
  // Handle click on premium feature
  const handlePremiumFeatureClick = (e: React.MouseEvent) => {
    if (!isPremium) {
      e.preventDefault();
      setShowUpgradeMessage(true);
      onUpgradeRequired();
      return false;
    }
    return true;
  };
  
  return {
    hasPremiumAccess: isPremium,
    handlePremiumFeatureClick,
    showUpgradeMessage,
    setShowUpgradeMessage,
    isLoading
  };
}
